// userInfo에 brand 값을 넣어서 VMD앱 해당 브랜드인지 체크하는 util
export const checkBrandCode = (brand:string) => {
  const brandArray = ['M', 'X', 'I', 'A', 'V']
  const checked = brandArray.includes(brand);
  return checked;
};
